import React from "react";

import classnames from "classnames";
import { RowInvoice } from "../../types";

import styles from "./InvoiceRows.module.scss";

const InvoiceRows = ({
  name,
  value,
  rate,
  additionalValue,
  isTitle,
  withBorder,
  withBoldBorder,
  isTotal,
  isSubtotal,
  isGrandTotal,
  isRedValue,
  valuesStyles,
}: RowInvoice) => {
  return (
    <tr
      className={classnames(styles.invoiceRow, {
        [styles.title]: isTitle,
        [styles.border]: withBorder,
        [styles.borderBold]: withBoldBorder,
        [styles.total]: isTotal,
        [styles.subtotal]: isSubtotal,
        [styles.grandTotal]: isGrandTotal,
      })}
    >
      <td>{name}</td>
      {rate == null && <td />}
      {additionalValue == null && <td />}
      <td className={classnames(valuesStyles, { [styles.red]: isRedValue })}>
        {value}
      </td>
      {rate != null && (
        <td className={classnames(valuesStyles, { [styles.red]: isRedValue })}>
          {rate}
        </td>
      )}
      {additionalValue != null && (
        <td className={classnames(valuesStyles, { [styles.red]: isRedValue })}>
          {additionalValue}
        </td>
      )}
    </tr>
  );
};

export default InvoiceRows;
